import React, {useContext} from "react";
import {VideoContext} from "../../context/VideoContext";
import { Link, useNavigate } from 'react-router-dom';
import './ProgramPage.scss';

const truncate = (text, n) => {
    if (!text) return '';
    if (text.length <= n) return text;
    return text.slice(0, n).trimEnd() + '...';
};

const ProgramPage = () => {
    const {youtubeData} = useContext(VideoContext);
    const navigate = useNavigate();

    const handleCardKey = (e, id) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate(`/programlar/${id}`);
        }
    };

    const scrollToPrograms = (e) => {
        e && e.preventDefault();
        const el = document.querySelector('.program');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return(
        <div className={"programlar page-programs"}>
            <div className={"program-header"}>
                <div className="main-slider-program">
                    <div className={"bg2-color"} aria-hidden></div>
                    <div className="hero-content" aria-hidden>
                        <div className="hero-inner">
                            <h1 className="hero-title">OBB TV</h1>
                            <p className="hero-lead">Ordu Büyükşehir Belediyesi'nin güncel programları, haberleri ve özel yayınları — hepsi burada.</p>
                            <div className="hero-ctas">
                                <button className="hero-cta" onClick={scrollToPrograms}>Programları Gör</button>
                                <Link className="hero-secondary" to="/canli-yayin">Canlı Yayın</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"program-title"}>
                Programlar
            </div>
            <div className={"program-subtitle"}>En yeni ve popüler programlardan seçkiler</div>

            <div className={"program container"}>
                {youtubeData?.playlists && youtubeData.playlists.map((item, index) => {
                   const thumb = item?.videos && item.videos[0] ? item.videos[0].thumbnail : process.env.PUBLIC_URL + '/images/logo192.png';
                   const title = item?.title || 'Program';
                   const id = item?.id || index;
                   const count = item?.videos?.length || item?.itemCount || 0;
                   const excerptSource = item?.description || item?.videos?.[0]?.title || '';
                   const excerpt = truncate(excerptSource.replace(/(<([^>]+)>)/gi, ''), 110);
                   return(
                       <div
                           className={"program-item"}
                           key={id}
                           role="article"
                           tabIndex={0}
                           onClick={(e)=>{ if ((e.target.closest && e.target.closest('.actions'))){ return; } navigate(`/programlar/${id}`);} }
                           onKeyDown={(e)=>handleCardKey(e, id)}
                           style={{animationDelay: `${index * 60}ms`}}
                       >
                            <div className={"program-thumb"}>
                                <img src={thumb} alt={title} loading="lazy"/>
                                {count > 0 && <div className="program-badge" aria-hidden>{count}</div>}
                                <div className="play-dot" aria-hidden>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 5v14l11-7L8 5z" fill="#0b2340"/></svg>
                                </div>
                                {excerpt && <div className="program-excerpt" aria-hidden>{excerpt}</div>}
                            </div>
                            <div className={"program-desc"}>
                                <div>
                                    <div className="program-name">{title}</div>
                                    <div className="program-meta">{count} bölüm</div>
                                </div>
                            </div>
                            <div className="program-footer">
                                <span className="program-meta">{count} bölüm</span>
                                <div className="actions">
                                    {/* prefer to open the first video in the playlist; fall back to playlist page */}
                                    {(() => {
                                        const firstVideoId = item?.videos && item.videos[0] ? item.videos[0].id : null;
                                        const inceleHref = firstVideoId ? `/programlar/${firstVideoId}?videoId=${firstVideoId}` : `/programlar/${firstVideoId}`;
                                        return (
                                            <Link className="btn-view" to={inceleHref} onClick={(e)=>e.stopPropagation()} aria-label={`İncele ${title}`}>
                                                <span className="btn-icon">🔍</span>
                                                <span>İncele</span>
                                            </Link>
                                        );
                                    })()}
                                    <Link className="btn-play" to={`/programlar/${id}?play=1`} aria-label={`Oynat ${title}`} onClick={(e)=>e.stopPropagation()}>▶</Link>
                                </div>
                            </div>
                       </div>
                   )
                 })}
             </div>
         </div>
     )
 }

 export default ProgramPage;
